import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth';

interface Props {
  children: ReactNode;
}

export default function AdminGate({ children }: Props) {
  const { isAdmin, loading } = useAuth();
  if (loading) return <p className="p-4 text-center">Laddar…</p>;
  if (!isAdmin) {
    return (
      <div className="max-w-md mx-auto mt-16 bg-white rounded-lg shadow p-6">
        <h1 className="text-xl font-bold mb-2 text-navy">Åtkomst nekad</h1>
        <p className="text-sm">Den här sidan är endast för styrelsen.</p>
      </div>
    );
  }
  return <>{children}</>;
}
